// src/components/EditDialog.js
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useServiceContext } from '../../components/Context/ServiceContext';

const EditDialogAdditionalService = ({
    open,
    handleClose,
    type, // 'brand' or 'model'
    currentData,
    brands,
    handleSave,
}) => {
    const [name, setName] = useState('');
    const [Id, setId] = useState('');
    const { editType } = useServiceContext();

    useEffect(() => {
         
        if (currentData) {
            setName(currentData.name || '');
            setId(currentData.id || '');
        }
    }, [currentData]);

    const onSave = () => {
        if (type === 'additionalservice') {
            if (name.trim() === '' || Id === '') {
                alert('Category name cannot be empty.');
                return;
            }
            handleSave({ ...currentData, name: name.trim(), id: Id });
        }
        handleClose();
    };





    return (
        <div>
            {editType === "additionalservice" &&
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Edit Additional Service</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Service Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            fullWidth
                            margin="dense"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button
                            onClick={onSave}
                            color="primary"
                            variant="contained"
                            disabled={type === 'brand' ? name.trim() === '' : name.trim() === '' || Id === ''}
                        >
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>}</div>
  );
};

export default EditDialogAdditionalService;
